import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=1ddd9810&scoped=true"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"
import style0 from "./Link.vue?vue&type=style&index=0&id=1ddd9810&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddd9810",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ddd9810')) {
      api.createRecord('1ddd9810', component.options)
    } else {
      api.reload('1ddd9810', component.options)
    }
    module.hot.accept("./Link.vue?vue&type=template&id=1ddd9810&scoped=true", function () {
      api.rerender('1ddd9810', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Sector/Post/Card/Link.vue"
export default component.exports